export default __webpack_public_path__ + "static/media/register.9ce99f64.png";